import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// view components
import FieldContent from '../../../FieldContent'
// types
import { IField } from 'types/graphql'
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// views
import { FieldsContainer } from '../../views'

interface Props {
  form: string
  templateFields: IField[]
}

// parent form properties are read only here, the form only keeps their values apart from the risk form
const ParentFieldsForm: React.FC<Props & InjectedFormProps<Record<string, any>, Props>> = ({ form, templateFields }) => (
  <FieldsContainer>
    {templateFields.map((field) => (
      <FieldContent disabled key={field.id} form={form} field={field} name={`${field.name}.value`} />
    ))}
  </FieldsContainer>
)

export default reduxForm<Record<string, any>, Props>({
  enableReinitialize: true
})(ParentFieldsForm)
